<template>
	<mu-container fluid class="px-0">
		<mu-row class="mt-4">
			<mu-col class="d-flex justify-content-center align-items-center">
				<img src="@@/images/logos/mexcar.svg" alt="mex car" width="200">
			</mu-col>
		</mu-row>
        <!-- Start Web Component -->
		<div>
			<div v-if="env === 'local'" ref="webComponentContainer"></div>
			<mex-car v-else/>
		</div>
        <!-- End Web Component -->
	</mu-container>
</template>

<script>
// HELPERS
import _GlobalHelper from "@/store/helpers/global";
// VUEX
import { mapMutations } from "vuex";

export default {
	name: "mexcar",
	data() {
		return {
			env: process.env.APP_ENV,
		};
	},
	computed: {
		loading: {
			set(data) {
				this.set_loading(data);
			},
			get() { },
		}
	},
	methods: {
		...mapMutations({
			set_loading: _GlobalHelper.mutations.loading,
		}),
	},
	mounted() {
		if (this.env === 'local') {
			// Solo carga el script si no está registrado aún
			if (!window.customElements.get('mex-car')) {
				const script = document.createElement('script');
				script.src = `http://localhost:5170/dist/mex-car.umd.js?v=${new Date().getTime()}`;
				script.async = true;
				script.onload = () => {
					// Una vez que el script esté cargado, monta el componente
					const component = document.createElement('mex-car');
					this.$refs.webComponentContainer.appendChild(component);
				};
				document.body.appendChild(script);
			} else {
				// Si el componente ya está registrado, solo agrégalo al contenedor
				const component = document.createElement('mex-car');
				this.$refs.webComponentContainer.appendChild(component);
			}
		}
	},
	created() {
		this.loading = {show: true, message: `<h5>${this.$i18n.t("loading.global")}</h5>`, timeout_active: true};
	},
};
</script>

<style>
	/* N/A */
</style>